import React from 'react';
import { AddOperandButton, OperatorType } from '@fabric-ui/components';
import { Delete } from '@fabric-ui/icons';
import { Box, IconButton } from '@mui/material';
import { useExpressionBuilder } from './ExpressionBuilderContext';
import { useFilterConfig } from './FilterContext';

interface DeleteAddFilterProps {
  level?: number;
  oppositeOperator: OperatorType;
  rootOperator: OperatorType | 'expression';
  onAdd?: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

const DeleteAddFilter: React.FC<DeleteAddFilterProps> = ({ level, oppositeOperator, rootOperator, onAdd, onDelete, disabled }) => {
  const { size, isVertical } = useFilterConfig();
  const { disableMessage } = useExpressionBuilder();
  return (
    <Box
      className={
        isVertical
          ? 'option flex flex-col items-center gap-1 opacity-0'
          : 'ml-1 flex grow flex-row-reverse items-center justify-between gap-1 opacity-100'
      }>
      <IconButton onClick={onDelete} disabled={disabled} aria-label="Delete">
        <Delete />
      </IconButton>
      {onAdd && (
        <AddOperandButton
          isAdd
          hideText={isVertical}
          size={size}
          operator={level === 0 ? oppositeOperator : rootOperator === OperatorType.OR ? OperatorType.OR : OperatorType.AND}
          onClick={onAdd}
          disabled={disabled}
          disableMessage={disableMessage}
        />
      )}
    </Box>
  );
};

export default DeleteAddFilter;
